import ReportSegmentAndSegmentOfSegmentV2 from './reportSegmentAndSegmentOfSegmentV2'
export default ReportSegmentAndSegmentOfSegmentV2
